import { ReactElement, useEffect } from "react";
import { renderToString } from "react-dom/server";
import { useHistory } from "react-router-dom";
import { getColorVariables } from "../../../shared/helpers";
import { IComponent } from "../../../services/http/component/models/IComponent";
import Marker from "../../../components/Map/Marker";
import StatusIndicator from "../../../components/Shared/StatusIndicator";
import styles from "./MapMarkers.module.scss";

interface MapMarkersProps
{
    markers: IComponent[] | undefined;
    current: IComponent | undefined;
    setCurrent: (x?: IComponent) => void;
}

const MapMarkers = (props: MapMarkersProps): ReactElement =>
{
    const history = useHistory();
    const markerCtaId = `cta_${props.current?.id}`;

    const getMarkerColor = (status: number): string =>
    {
        return getColorVariables(status);
    };

    const setMarkerPopupHtml = (x: IComponent): string =>
    {
        return renderToString(
            <>
                <small>{x.parentName}</small>

                <h1>
                    {x.name} -
                    <StatusIndicator
                        component={x}
                        customClassName={styles.statusIndicator}
                        inverted
                    />
                </h1>

                <button id={markerCtaId} className="btn btn-info-light">
                    Review in dashboard
                    <i className="material-icons">arrow_forward</i>
                </button>
            </>
        );
    };

    useEffect(() =>
    {
        if (props.current && props.current.id)
        {
            const currentId = props.current.id;
            const markerCta = document.querySelector(`#${markerCtaId}`);
            markerCta?.addEventListener("click", () => history.push(`/dashboard/${currentId}`));
        }
        else
        {
            return;
        }
    }, [markerCtaId, history, props]);

    return (
        <div className={styles.markersContainer}>
            {props.markers?.map(x => (
                <Marker
                    key={x.id}
                    id={`marker_${x.id}`}
                    position={[x.longitude, x.latitude]}
                    options={{ color: getMarkerColor(x.healthIndicatorStatusId) }}
                    onClick={() => props.setCurrent(x)}
                    popup={{
                        visible: props.current?.id === x.id,
                        html: setMarkerPopupHtml(x)
                    }}
                />
            ))}
        </div>
    );
};

export default MapMarkers;
